import { gqlCountryEnum as countryType } from '@minecraft.graphql-types';
import { appConfig as globalAppConfig } from '@minecraft.app-config';
import { getEnvironment } from '@minecraft.environment';

const env = getEnvironment();
const cdnRoot = env.CDN_URL;

const appConfig = {
  cdnRoot,
  companyName: 'Casting Networks',
  appName: 'Talent',
  svgRoot: `${cdnRoot}/images/icons/b21/`,
  defaultCountryCode: countryType.US,
  countryAllKey: globalAppConfig.allCountriesCode,
  defaultLanguageCode: 'en',
  defaultMeasurementUnit: 'imperial', // vs metric

  placeholderImgRoot: '//via.placeholder.com/',

  photoExtensions: ['jpg', 'png', 'gif', 'jpeg'],

  // Size modifier value 2 - Regular for Girl, Toddler and Infant
  sizeModifierId: '2',
  defaultResultSizeOptions: [25, 50, 100],

  projectSearchPageSize: 50,
  projectSearchPageSizes: [25, 50, 100],
};

export default appConfig;
